import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DetalleCaja, Mercaderia } from 'src/app/model/index.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalleCajaService } from 'src/app/service/index.service';
import { NgForm } from '@angular/forms';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';

@Component({
  selector: 'app-frm-detalle-caja',
  templateUrl: './frm-detalle-caja.component.html',
  styleUrls: ['./frm-detalle-caja.component.css']
})
export class FrmDetalleCajaComponent implements OnInit {

  /*
 * Varaiables de control para comportamientos del componente
 */
  @Output()
  finalizado: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  @Output()
  cancelado: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  /*
   * control de operaciones a realizar
   */
  proccess: Boolean;
  filtro: number = 0;

  public entity = 'detallecajas';
  public item: DetalleCaja;
  private id: number;

  motivos: String[];
  ingresos = ['Apertura de caja', 'Ingreso para pagos', 'Cierre de caja', 'Cobro']
  egreso = ['Pago proveedor', 'Saldos virtual', 'Cobros con debito', 'Devolución']

  constructor(private route: ActivatedRoute, private router: Router, private wsdl: DetalleCajaService) {
    this.item = new DetalleCaja();
  }

  dataChanged(event) {
    if (event == "e") {
      this.motivos = this.egreso;
    } else {
      this.motivos = this.ingresos;
    }

  }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.findID();
  }

  async findID() {
    try {
      if (this.id > 0) {
        let data = await this.wsdl.doFind(this.id).then();
        let res = JSON.parse(JSON.stringify(data));
        if (res.code == 200) {
          this.item = res.data;
        }
      }
    } catch (error) {
      UturuncoUtils.showToas("Error inesperado", "error");
    }

  }

  @Input()
  set select(item: DetalleCaja) {
    if (item.id === undefined) {
      this.item = new DetalleCaja();

    } else {
      this.item = new DetalleCaja();
      this.item = item;
    }

  }

  doAction(f: NgForm) {
    /* validar */
    this.item.caja = JSON.parse(UturuncoUtils.getSession("caja"));
    if (f.valid) {
      if (this.id > 0) {
        //editar
        this.doEdit();
      } else {
        this.doCreate();
      }
    } else {
      alert('Validar');
    }
  }

  async doEdit() {
    try {

      this.proccess = true;
      const res = await this.wsdl.doUpdate(this.item, this.item.id).then();
      const result = JSON.parse(JSON.stringify(res));

      if (result.code == 200) {
        UturuncoUtils.showToas("Se actualizado correctemte", "success");
        this.finalizado.emit(true);
      } else if (result.code == 666) {
        // logout app o refresh token
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    }
    this.proccess = false;
  }

  async  doCreate() {
    try {

      this.proccess = true;
      const res = await this.wsdl.doInsert(this.item).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        UturuncoUtils.showToas("Se creo correctemte", "success");
        this.finalizado.emit(true);
      } else if (result.code == 666) {
        // logout app o refresh token
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    }
  }

  back() {
    this.router.navigateByUrl("admin/" + this.entity.toLowerCase() + "/lst/");
  }

}


